import { RowData, SortingFn } from '@tanstack/react-table';

export function i18nSortingFn<T extends string, TData extends RowData>(i18n: Record<T, string>): SortingFn<TData> {
  return (rowA, rowB, columnId) => i18n[rowA.getValue<T>(columnId)].localeCompare(i18n[rowB.getValue<T>(columnId)]);
}
